import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "../components/HeroSection";
import FeatureGrid from "../components/FeatureGrid";
import WorkflowStrip from "../components/WorkflowStrip";
import SciencePreview from "../components/SciencePreview";
import TrustSection from "../components/TrustSection";
import WaitlistSection from "../components/WaitlistSection";

const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const targetId = location.hash.replace("#", "");
    const el = document.getElementById(targetId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.hash]);

  return (
    <>
      <HeroSection />
      <FeatureGrid />
      <WorkflowStrip />
      <SciencePreview />
      <TrustSection />
      <WaitlistSection />
    </>
  );
};

export default LandingPage;
